import { DisplayTrixContent } from "@circle-react-shared/uikit/DisplayTrixContent";
import { DisplayTiptapContent } from "@circle-react/components/CommentsV3/Comment/DisplayTiptapContent";
import { getDetailedTimestamp } from "@circle-react/helpers/postHelpers";
import { Link } from "@tanstack/react-router";
import { format } from "date-fns";

import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";
import { UserImage } from "@/react/components/SettingsApp/CompassCompat/UserImage";

import { COMMENT_ANCHOR_PREFIX } from "../../CommentsCompass/constants";

interface AgentCommentProps {
  comment: {
    id: number;
    post_slug: string;
    space_slug: string;
    post_name?: string;
    post_truncated_content?: string;
    created_at: string;
    updated_at: string;
    tiptap_body: object;
    body_trix_content: string;
    editor: "trix" | "tiptap";
  };
  member: {
    id: number;
    name: string;
    avatar_url: string;
  };
  onClose: () => void;
}

export const AgentComment = ({
  comment,
  onClose,
  member,
}: AgentCommentProps) => {
  const dateString = format(new Date(comment.created_at), "MMM dd");
  return (
    <Link
      to="/c/$spaceSlug/$postSlug"
      params={{
        spaceSlug: comment.space_slug,
        postSlug: comment.post_slug,
      }}
      hash={`${COMMENT_ANCHOR_PREFIX.replace(/^#/, "")}${comment.id}`}
      onClick={onClose}
      className="flex w-full min-w-0 items-start space-x-3 overflow-hidden py-5 first:pt-0"
    >
      <div className="mt-1">
        <UserImage
          isFullRounded
          name={member.name}
          src={member.avatar_url}
          size="10"
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex w-full min-w-0 items-center justify-between space-x-2">
          <div className="text-default w-full min-w-0 flex-1 truncate text-sm">
            {t("profile_drawer.comments.commented_on")}{" "}
            <span className="text-dark dark:text-darkest font-medium">
              {comment.post_name || comment.post_truncated_content}
            </span>
          </div>
          <div>
            <TippyV2
              interactive={false}
              content={getDetailedTimestamp(comment.created_at)}
            >
              <span className="text-default text-sm">{dateString}</span>
            </TippyV2>
          </div>
        </div>
        {comment.editor === "tiptap" ? (
          <DisplayTiptapContent
            key={comment.updated_at}
            tiptapBody={comment.tiptap_body}
          />
        ) : (
          <DisplayTrixContent content={comment.body_trix_content} />
        )}
      </div>
    </Link>
  );
};
